import type { SystemProps } from '@xstyled/styled-components'
import styled from '@xstyled/styled-components'
import { Slider, SliderFilledTrack, SliderThumb, SliderTrack } from '../slider'
import type { SliderSize } from '../slider/types'

type AnimationValues = {
  root: {
    size: SliderSize
  }
  thumb: SystemProps
}

const sliderAnimationMap: Record<'initial' | 'final', AnimationValues> = {
  initial: {
    root: {
      size: 'md'
    },
    thumb: {
      scale: 0
    }
  },
  final: {
    root: {
      size: 'lg'
    },
    thumb: {
      scale: 1
    }
  }
}

export function getSliderAnimationValues(
  animation: 'initial' | 'final'
): AnimationValues {
  return sliderAnimationMap[animation]
}

export const StyledSlider = styled(Slider)<{ animated?: boolean }>(
  props =>
    props.animated && {
      transition: 'padding 150ms',
      '&::before': {
        content: "' '",
        position: 'absolute',
        top: '-18px',
        bottom: '-8px',
        width: '100%'
      }
    }
)

export const StyledSliderThumb = styled(SliderThumb)<{ animated?: boolean }>(
  props => ({
    background: props.theme.colors.primary.base,
    boxShadow: 'none'
  }),
  props =>
    props.animated && {
      left: '-calc(var(--slider-thumb-size) / -2)',
      transitionProperty: 'transform, height, width, box-shadow',
      transform: `translate(calc(var(--slider-thumb-size) / -2), -50%) scale(${props.scale})`,
      '&:active, &[data-active]': {
        transform: `translate(calc(var(--slider-thumb-size) / -2), -50%) scale(1.15)`
      }
    }
)

export const StyledSliderTrack = styled(SliderTrack)<{ animated?: boolean }>(
  props =>
    props.animated && {
      transitionProperty: 'height',
      transitionDuration: '150ms'
    }
)

export const StyledSliderTrackFilled = styled(SliderFilledTrack)<{
  animated?: boolean
}>(
  {
    width: '0%'
  },
  props =>
    props.animated && {
      borderRadius: 'var(--slider-track-border-radius)'
    }
)
